import { lazy } from 'react';

export const RegistrationCongrats = lazy(() => import('./Congrats.component'));
